// extracted by mini-css-extract-plugin
export var cartContainer = "_nt-4";
export var gray = "_nt-1";
export var itemContainer = "_nt-2";
export var itemDetails = "_nt-3";
export var strong = "_nt-0";